import 'axios';
import { transformCustomer, transformCustomerAddress, transformCustomerAddressRequest } from '../transformers/customer/index.js';
import { transformSalesCartItemsResponse } from '../cart/transformers.js';

const transformCrmCustomerMeResponse = transformCustomer;
const transformCrmCustomerMeAddressesShippingResponse = (address)=>transformCustomerAddress(address);
const transformCrmCustomerMeAddressesBillingResponse = (address)=>transformCustomerAddress(address);
const transformCrmCustomerMeAddressesListResponse = (addresses)=>addresses.map((address)=>transformCustomerAddress(address));
const transformCrmCustomerMeAddressRequest = ({ address , defaultShipping , defaultBilling  })=>{
    return {
        ...transformCustomerAddressRequest(address),
        default_shipping: defaultShipping,
        default_billing: defaultBilling
    };
};
const transformCrmCustomerMeSalesAgentsResponse = (agents)=>{
    return {
        agents: agents.map((agent)=>transformCustomerSalesAgent(agent))
    };
};
const transformCustomerSalesAgent = ({ id , email , firstname , lastname , studio_photo: companyPhoto , photo , specialization , description , communications , company_name: companyName , vat_number: vatNumber , telephone , street , city , zipcode , state , country  })=>({
        id,
        firstname,
        lastname,
        email,
        companyPhoto,
        photo,
        specialization,
        description,
        communications,
        companyName,
        vatNumber,
        telephone,
        street,
        city,
        zipcode,
        state,
        country
    });
const transformCrmCustomerMeQuotesResponse = ({ count , items  })=>({
        count,
        items: items.map((item)=>transformQuoteResponse(item))
    });
const transformCrmCustomerMeQuoteResponse = (data)=>transformQuoteResponse(data);
const transformCrmCustomerMeQuoteTokenResponse = (data)=>transformQuoteResponse(data);
const transformQuoteResponse = ({ created_at: createdAt , customer_id: customerId , customer_data: customerData , description: quoteDescription , description2: quoteAdditionalDescription , entity_id: id , items , name , sales_agent_data: salesAgentData , state , token  })=>({
        createdAt,
        customerId,
        customerData,
        quoteDescription,
        quoteAdditionalDescription,
        id,
        items: items?.map((item)=>transformSalesCartItemsResponse(item)),
        name,
        salesAgentData: transformCustomerSalesAgent(salesAgentData),
        state,
        token,
        totals: items?.reduce((acc, item)=>acc + item?.price * item?.qty, 0)
    });

export { transformCrmCustomerMeAddressRequest, transformCrmCustomerMeAddressesBillingResponse, transformCrmCustomerMeAddressesListResponse, transformCrmCustomerMeAddressesShippingResponse, transformCrmCustomerMeQuoteResponse, transformCrmCustomerMeQuoteTokenResponse, transformCrmCustomerMeQuotesResponse, transformCrmCustomerMeResponse, transformCrmCustomerMeSalesAgentsResponse, transformCustomerSalesAgent, transformQuoteResponse };
